import React, { useState, useEffect } from "react";
import AuthUtility from "../../util/AuthUtility";
import { Link, useNavigate } from 'react-router-dom';

const Home = () => {
    const navigate = useNavigate();
    
    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        }
    })

    return (
        <div className="container-fluid">
        <div className="title-wrapper pt-30">
            <div className="row align-items-center">
                <div className="col-md-6">
                    <div className="title d-flex align-items-center flex-wrap mb-30">
                        <h2 className="mr-40">Welcome to Rain Auction admin panel.</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Home;
